module.exports = ":host .ad-container {\n  width: 100%;\n  height: 100%;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/ad/ad.style.scss
// module id = 839
// module chunks = 2